import { Component, OnInit, Output, EventEmitter } from '@angular/core';
declare var jQuery:any;
declare var $:any;

@Component({
    selector: 'formulario-monte',
    templateUrl: './monte.component.html',
    styleUrls: ['./monte.component.css']
})
export class MonteComponent implements OnInit {

    public arrMontes:Array<any>;
    public msgError:string;
    public error:boolean;

    public arrayMontesSend:Array<any>;
    public indexMontes:any;

    @Output() sendInfo = new EventEmitter();
    @Output() sendMontes = new EventEmitter();

    constructor() {
        this.arrMontes = [];
        this.arrayMontesSend=[];
        this.error=false;
    }

    ngOnInit(): void {
        this.initArraymontes();
    }

    public initArraymontes():void{
            this.arrMontes.push({
                "ha": "",
                "wood_age": "",
                "wood_type": ""
            });
    }

    public setMont(xindex:number):void{
        if(this.arrMontes.length <= 4){
            this.arrMontes.push({
                "ha": "",
                "wood_age": "",
                "wood_type": ""
            });
        }else{
            this.error=true;
            this.msgError = 'Solo puede guardar un máximo de 5 montes.'
            setTimeout(()=>{
                this.error=false;
            },5000);
        }
        
    }

    public setDataMontes():void{
        for(let x = 0;x<this.arrMontes.length;x++){
            this.arrMontes[x].ha = $('#ha'+x).val();
            this.arrMontes[x].wood_age = $('#wood_age'+x).val();
            this.arrMontes[x].wood_type = $('#wood_type'+x).val();
        }
        this.sendMontes.emit(this.arrMontes);
    }

    public removeMont():void{
        this.arrMontes.pop();
    }

    public sendEmitInfo():void{
        this.sendInfo.emit(this.arrMontes);
    }
}
